import React from "react"
import { DrawerSeeker } from "@ui-seeker/core"

import { isAlertsDrawerOpen, alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { alertsSection } from "Pages/ReportsAlerts/Alerts/@signals"


export default function AlertsBaseDrawer({footer, content}) {

	return <DrawerSeeker
		title={`${alertsSection.value}: ${alertsDrawerData.peek().idAlert ? `${alertsDrawerData.peek().conditionName}` : 'Create a new Alert'}`}
		anchor="right"
		width="40%"
		variant="persistent"
		isOpen={isAlertsDrawerOpen.value}
		customFooter={footer}
	>
		{content}
	</DrawerSeeker>
}